import { WarningAmberOutlined, CloseOutlined } from '@mui/icons-material';
import { Button } from 'finara-components';
import React from 'react';

interface ConfirmDeleteUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  userName: string;
  isLoading?: boolean;
}

export const ConfirmDeleteUserModal: React.FC<ConfirmDeleteUserModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  userName,
  isLoading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <button
        className="absolute inset-0 bg-black opacity-60 cursor-default"
        onClick={onClose}
        aria-label="Cerrar modal"
        type="button"
      />

      {/* Modal */}
      <div className="relative z-10 bg-surface border border-black/10 dark:border-white/15 rounded-lg shadow-2xl shadow-black/60 max-w-md w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-red-500/20 rounded-full flex items-center justify-center">
              <WarningAmberOutlined className="text-red-400" />
            </div>
            <h2 className="text-xl font-semibold text-brand-white">Confirmar Eliminación</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-muted hover:text-brand-white transition-colors"
            disabled={isLoading}
            type="button"
          >
            <CloseOutlined />
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <p className="text-brand-white mb-2">
            ¿Estás seguro de que deseas eliminar a <strong>{userName}</strong>?
          </p>
          <p className="text-sm text-muted">
            Esta acción no se puede deshacer. Toda la información del usuario será eliminada
            permanentemente.
          </p>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-6 border-t border-border">
          <Button variant="white" onClick={onClose} disabled={isLoading} type="button">
            Cancelar
          </Button>
          <Button
            variant="black"
            onClick={onConfirm}
            disabled={isLoading}
            className="!bg-red-600 hover:!bg-red-700"
            type="button"
          >
            {isLoading ? 'Eliminando...' : 'Eliminar Usuario'}
          </Button>
        </div>
      </div>
    </div>
  );
};
